import { ProgressBarProps } from "react-aria-components";
import { ReactNode } from "react";

export enum MDSProgressBarColor {
  Default = "default",
  Success = "success",
  Primary = "primary",
  Emphasis = "emphasis",
  Brand = "brand",
  Danger = "danger",
}

export interface MDSProgressBarProps extends ProgressBarProps {
  /**
   * The label for the progress bar.
   */
  label?: ReactNode;

  /**
   * Whether to show the value label alongside the progress bar.
   */
  showValueLabel?: boolean;

  /**
   * Custom size variant for the progress bar.
   */
  size?: MDSProgressBarSize;

  /**
   * Custom color variant for the progress bar.
   */
  color?: MDSProgressBarColor;

  /**
   * Direction of the progress bar fill.
   * @default "ltr" (left-to-right)
   */
  direction?: MDSProgressBarDirection;

  /**
   * When true, the progress bar uses fully rounded corners (pill shape).
   */
  rounded?: boolean;

  animation?: {
    duration?: number;
    direction?: MDSProgressBarAnimationDirection;
    paused?: boolean;
    onComplete?: () => void;
  };
}

export type MDSProgressBarSize = "small" | "medium" | "large" | "xlarge";

export type MDSProgressBarDirection = "ltr" | "rtl";

export type MDSProgressBarAnimationDirection = "increase" | "decrease";
